import React, {useEffect} from "react"
import { Box, Flex, SimpleGrid } from "@chakra-ui/core"

import MaxWidthGrid, { MaxWidthGridProps } from "../Layout/MaxWidthGrid"
import BikeProductCard, { BaseBikeProductCardProps } from "../BikeProductCard"
import ToolTip from "../../components/ToolTip"
import Body from "../typography/Body"
import { useSelector, useDispatch } from "react-redux"
import { BaseRootState, BaseDispatch } from "../../redux/store"
import { bpWithSidebar } from "../../utils/MediaQueries"
import { useDisclosure } from "@chakra-ui/core"
import BodyFitQuizBox from "../../components/BodyFitQuizBox"

import "../../views/party-effect.css";
import ConfettiLoad from "./ConfettiEffect"

export type BikeListLayoutProps = MaxWidthGridProps & {
  bikes: Array<{ id: string } & BaseBikeProductCardProps>
  header?: JSX.Element
  inStockFilter?: JSX.Element
  inStockFilterCenter?: JSX.Element
  tooltipLabel?: string
  featureFirstBike?: boolean
  enableBoxQuiz?: any
  boxQuizImage?: any
  boxQuizPosition?: any
}

const BikeListLayout: React.FC<BikeListLayoutProps> = ({
  bikes,
  header,
  inStockFilter,
  inStockFilterCenter,
  tooltipLabel,
  featureFirstBike = false,
  enableBoxQuiz,
  boxQuizImage,
  boxQuizPosition,
  ...props
}) => {
  const {
    sidebar: { isOpen: sidebarOpen },
  } = useSelector((state: BaseRootState) => state)

  // Mobile Quiz drawer
  const { isOpen, onClose, onOpen } = useDisclosure()
  // Redux
  const dispatch = useDispatch<BaseDispatch>()

  const {
    quiz: {
      currentQuestionIndex,
      questions,
      quizProgressState,
      previousQuizAnswers,
      answers,
      currentPreviousAnswersDate,
    },
  } = useSelector((state: BaseRootState) => state)

  useEffect(() => {
    // This code will be executed after the component is mounted and the DOM is ready
    setTimeout(function () {
      const confettiCanvas = document.getElementById("drawing_canvas");
      if (confettiCanvas) {
        // Call the ConfettiLoad method here
        ConfettiLoad();
      }
    }, 1000);
  }, []);

  return (
    <>
      {header}
      {/*tooltipLabel && bikes.length > 0 && (
        <Flex justifyContent="center" alignItems="flex-start">
          <ToolTip label={tooltipLabel} isOpen position="top">
            <Box w="100vw" h="1.25rem" />
          </ToolTip>
        </Flex>
      )*/}
      <MaxWidthGrid {...props}>
        {bikes.length === 0 && (
          <Box
            textAlign="center"
            gridColumn={["1/end", null, null, null, "2/14", "1/end"]}
            pt="20"
          >
            <Box>{inStockFilterCenter}</Box>
            <Body color="dawn">No bikes available</Body>
          </Box>
        )}
        {featureFirstBike && bikes.length > 0 && (
          <Flex align="center" justify="center" gridColumn="1/end">
            {/* <Box className="confetti">
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
                <Box className="confetti-piece"></Box>
            </Box> */}
            <canvas id="drawing_canvas"></canvas>
            <BikeProductCard
              featureFirstBike={true}
              {...bikes[0]}
              width={bpWithSidebar("100%", "100%", sidebarOpen)}
              maxWidth="100%"
              inStockFilter={inStockFilter}
            />
          </Flex>
        )}
        <SimpleGrid
          columns={
            sidebarOpen
              ? [1, null, null, null, null, 2, 3]
              : [1, null, null, null, 2, 3]
          }
          gridColumn={["1/end", null, null, null, "2/14", "1/end"]}
          marginX={[null, null, null, null, null, "1.25rem"]}
          alignItems="stretch"
          spacing="1rem"
        >
          {bikes.slice(featureFirstBike ? 1 : 0).map((bike, index) => (
            <>
              {index > 0 && enableBoxQuiz && index % boxQuizPosition === 0 && (
                <BodyFitQuizBox
                  boxQuizImage={boxQuizImage}
                  currentPagePath={"/"}
                  isSidebarOpen={true}
                  toggleSidebar={async () => {
                    await dispatch.sidebar.setAnimate(true)
                    dispatch.sidebar.toggleOpen()
                  }}
                  isMobileQuizDrawerOpen={isOpen}
                  onClose={() => {
                    if (quizProgressState === "inprogress") {
                      dispatch.quiz.setProgressState("paused")
                    }
                    onClose()
                  }}
                  onOpen={onOpen}
                  currentQuestionNumber={currentQuestionIndex + 1}
                  totalQuestionNumber={questions.length}
                  canGoToNextQuestion={
                    answers[questions[currentQuestionIndex]?.questionId] !==
                    undefined
                  }
                  onNextQuestion={() => {
                    if (
                      answers[questions[currentQuestionIndex].questionId] !==
                      undefined
                    ) {
                      dispatch.quiz.nextQuestion()
                    }
                  }}
                  onPrevQuestion={dispatch.quiz.prevQuestion}
                />
              )}
              <BikeProductCard key={bike.id} {...bike} />
            </>
          ))}
        </SimpleGrid>
      </MaxWidthGrid>
    </>
  )
}

export default BikeListLayout
